export default "__VITE_ASSET__b184c4b2__"